import React from 'react'
import { Loader2 } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'

type Props = {
  title: string
  message: string
  confirmLabel?: string
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmDialog: React.FC<Props> = ({
  title,
  message,
  confirmLabel = 'Confirm',
  loading = false,
  onConfirm,
  onCancel,
}) => {
  const { currentTheme: t } = useTheme()
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onCancel} />
      <div
        className="relative z-10 w-full max-w-sm mx-4 rounded-xl p-6 shadow-xl"
        style={{ backgroundColor: t.secondary, border: `1px solid ${t.border}` }}
      >
        <h3 className="text-sm font-semibold mb-1.5" style={{ color: t.text }}>{title}</h3>
        <p className="text-xs mb-6 leading-relaxed" style={{ color: t.mutedText }}>{message}</p>
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 rounded-lg text-sm font-medium transition-colors hover:opacity-80 disabled:opacity-50"
            style={{ backgroundColor: t.hoverBackground, border: `1px solid ${t.border}`, color: t.text }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-500 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading && <Loader2 size={13} className="animate-spin" />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(ConfirmDialog)
